<template>
  <svg
    class="va-icon-svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 12h14" />
  </svg>
</template>

<script setup lang="ts">
/**
 * Inline-SVG replacement for the Material Icons glyph `remove`, which
 * `VaCheckbox` consumes as its default `indeterminateIcon` (i.e. when
 * `indeterminate: true`). See `VuesticCheckboxCheckIcon.vue` for the
 * rationale — we do NOT load the Material Icons font, so Vuestic's
 * default would render the literal icon name as text inside the
 * checkbox square. Registering this component as the `remove` alias's
 * `component` (see `main.ts`) avoids that fallback.
 */
export interface VuesticCheckboxIndeterminateIconProps {}

defineProps<VuesticCheckboxIndeterminateIconProps>()
</script>
